import { render, staticRenderFns } from "./ChoroplethWorldMap.vue?vue&type=template&id=1da0712f&scoped=true"
import script from "./ChoroplethWorldMap.vue?vue&type=script&lang=js"
export * from "./ChoroplethWorldMap.vue?vue&type=script&lang=js"
import style0 from "./ChoroplethWorldMap.vue?vue&type=style&index=0&id=1da0712f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da0712f",
  null
  
)

export default component.exports